import { IAuthorizableGranteePermissions } from '../types/IAuthorizableGranteePermissions';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ISetExplicitPermissionsParams {
  permissions: IAuthorizableGranteePermissions[];
}

export interface ISetExplicitPermissionsResult extends IResult {
}

export class SetExplicitPermissionsRequest extends Request<ISetExplicitPermissionsParams, ISetExplicitPermissionsResult> {
  constructor(params: ISetExplicitPermissionsParams) {
    super('setExplicitPermissions', params);
  }
}
